import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { TickCircle } from './icon/icons/TickCircle';
import { TickListFragment } from '../types/graphqlTypes';
import { Spacer } from './Spacer';
import { Typography } from './Typography';
import HtmlContent from './Html';
import { createMarkup } from '../utils';

export const StyledTickList = styled.ul`
  ${({ theme: { space } }) => css`
    li {
      display: flex;
      align-items: center;
      gap: ${space.sm};

      & + li {
        margin-top: ${space.md};
      }

      svg {
        flex-shrink: 0;
      }
    }
  `};
`;

export const TickList: FC<Omit<TickListFragment, '__typename'>> = ({ items, title, lead, content, color, ...rest }) => {
  if (items.length < 1) {
    return null;
  }

  return (
    <Spacer>
      {title || lead || content ? (
        <Spacer spacing="half">
          {title && (
            <Typography component="h3" variant="titleLarge">
              {title}
            </Typography>
          )}
          {lead && (
            <Typography component="p" variant="lead">
              {lead}
            </Typography>
          )}
          {content && <HtmlContent>{content}</HtmlContent>}
        </Spacer>
      ) : (
        ''
      )}
      <StyledTickList {...rest}>
        {items.map((item, index) => (
          <li key={index}>
            <TickCircle size="medium" color={color || 'black'} />
            {createMarkup(item.text)}
          </li>
        ))}
      </StyledTickList>
    </Spacer>
  );
};
